import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/layout/Layout.vue';
import Home from '@/views/Home.vue';
import OrderList from '@/views/OrderList.vue';
import TransactionData from '@/views/TransactionData.vue';
import ProductDetail from '@/views/ProductDetail.vue';
import SalesSummaryList from '@/views/SalesSummaryList.vue';
import ProductList from '@/views/ProductList.vue';
import Login from '@/views/Login.vue';
import OrderDetail from '@/views/OrderDetail.vue';
import StoreOrderDetail from '@/views/StoreOrderDetail.vue';
import SalesOrderDetail from '@/views/SalesOrderDetail.vue';
import PurchaseDetail from '@/views/PurchaseDetail.vue';
import LoanApplication from '@/views/LoanApplication.vue';
import store from '@/store';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '/',
          name: 'Home',
          component: Home,
          meta: { requiresAuth: true }
        },
        {
          path: '/order-list',
          name: 'OrderList',
          component: OrderList,
          meta: { requiresAuth: true }
        },
        {
          path: '/sales-summary-list',
          name: 'SalesSummaryList',
          component: SalesSummaryList,
          meta: { requiresAuth: true }
        },
        {
          path: '/transaction-data',
          name: 'TransactionData',
          component: TransactionData,
          meta: { requiresAuth: true }
        },
        {
          path: '/product-detail/:id',
          name: 'ProductDetail',
          component: ProductDetail,
          meta: { requiresAuth: true }
        },
        {
          path: '/order-detail/:id',
          name: 'OrderDetail',
          component: OrderDetail,
          meta: { requiresAuth: true }
        },
        {
          path: '/store-order-detail/:id',
          name: 'StoreOrderDetail',
          component: StoreOrderDetail,
          meta: { requiresAuth: true }
        },
        {
          path: '/sales-order-detail/:id',
          name: 'SalesOrderDetail',
          component: SalesOrderDetail,
          meta: { requiresAuth: true }
        },
        {
          path: '/purchase-detail/:id',
          name: 'PurchaseDetail',
          component: PurchaseDetail,
          meta: { requiresAuth: true }
        },
        {
          path: '/product-list',
          name: 'ProductList',
          component: ProductList,
          meta: { requiresAuth: true }
        },
        {
          path: '/loan-application',
          name: 'LoanApplication',
          component: LoanApplication,
          meta: { requiresAuth: true }
        }
      ]
    }
  ]
});

// 路由守卫
router.beforeEach(async(to, from, next) => {
  // 获取token
  const token = store.state.token;
  // 获取登录状态
  const isLoggedIn = store.state.isLoggedIn;

  // 如果访问登录页面，直接放行
  if (to.path === '/login') {
    next();
    return;
  }

  // 如果访问需要认证的路由
  if (to.meta.requiresAuth) {
    // 检查是否有token
    if (!token) {
      // 没有token，跳转到登录页面
      next({ path: '/login' });
      return;
    }

    // 有token，但未登录或用户信息为空，尝试获取用户信息
    if (!isLoggedIn || !store.state.userInfo?.mobile) {
      try {
        // 调用获取用户信息的action
        await store.dispatch('getUserInfo');
        // 获取用户信息成功，放行
        next();
      } catch (error) {
        console.error('获取用户信息失败，跳转到登录页面:', error);
        // 获取用户信息失败，跳转到登录页面
        next({ path: '/login' });
      }
    } else {
      // 已登录且用户信息存在，直接放行
      next();
    }
  } else {
    // 不需要认证的路由，直接放行
    next();
  }
});

export default router;
